<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<header>
<h1 class="topictitle1" id="de1"><a href="#/nav#nde1"><span class="title">Dedication</span></a></h1>
</header>
<div class="dedication_group">
<p class="dedication">To two women who know how to be deep, dear, lifelong friends: Kerry Kern Woods and Lorrie Jenicek.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?e2d6cbe4